import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, getTranslation } from '@resy/ui-kitchen';

import './TimePicker.scss';
import { ALL_DAY } from '../../../../../../../ui-kitchen/src/constants/resyCore';

let futureDateTimeOptions;
let todayTimeOptions;

export default function TimePicker({
  dateSelected,
  onClick,
  onChange,
  timeSelected,
  timeOptions,
}) {
  const getTimeOptions = () => {
    let startTime = moment('06:00', 'HH:mm');

    if (dateSelected === 'Today') {
      const now = moment();
      const remainder = 30 - (now.minute() % 30);
      startTime = now.add(remainder, 'minutes').format('HH:mm');
    } else if (futureDateTimeOptions) {
      // use memoized value if already calculated, and if dateSelected is NOT today
      return futureDateTimeOptions;
    }

    let timeDisplay;
    let timeValue;

    const range = [{
      key: 'all-day',
      label: getTranslation({
        translationKey: 'time_picker_default_label',
        fallback: 'All Day',
      }),
      value: 'all-day',
    }];

    const endTime = moment('02:00', 'HH:mm').add(1, 'day');
    const tempTime = moment(startTime, 'HH:mm');

    while (tempTime <= endTime) {
      timeDisplay = tempTime.format('LT');
      timeValue = tempTime.format('HHmm');
      range.push({
        label: timeDisplay,
        value: timeValue,
        key: timeValue,
      });
      tempTime.add(30, 'minutes');
    }

    if (dateSelected === 'Today') {
      todayTimeOptions = range;
    } else {
      futureDateTimeOptions = range;
    }

    return range;
  };

  const getSelectedTime = () => {
    // for experiential marketing page
    if (timeOptions) {
      return timeSelected;
    }
    if (dateSelected === 'Today' && !todayTimeOptions?.find((time) => time.value === timeSelected)) {
      return ALL_DAY;
    } return timeSelected;
  };

  const timePickerLabel = getTranslation({
    translationKey: 'invite_time_label',
    fallback: 'Time',
  });

  return (
    <div className="TimePicker">
      <Dropdown
        name="time"
        theme="nav"
        onChange={onChange}
        onClick={onClick}
        options={timeOptions || getTimeOptions()}
        showChevron={false}
        selected={getSelectedTime()}
        ariaLabel={timePickerLabel}
      />
    </div>
  );
}

TimePicker.propTypes = {
  dateSelected: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  timeSelected: PropTypes.string,
  timeOptions: PropTypes.shape({}),
};

TimePicker.defaultProps = {
  onClick: () => {},
  onChange: () => {},
  timeSelected: ALL_DAY,
  timeOptions: null,
};
